function cov_830pg6psh() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Share.tsx";
  var hash = "7e7b3ac9caba83e66083d2602e1be25ec43649b6";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Share.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 45
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7e7b3ac9caba83e66083d2602e1be25ec43649b6"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_830pg6psh = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_830pg6psh();
var Icon = (cov_830pg6psh().s[0]++, {
  name: 'share',
  svg: "<path xmlns=\"http://www.w3.org/2000/svg\" d=\"M6.3077 22.5C5.80257 22.5 5.375 22.325 5.025 21.975C4.675 21.625 4.5 21.1974 4.5 20.6923V10.3077C4.5 9.80261 4.675 9.37504 5.025 9.02504C5.375 8.67504 5.80257 8.50004 6.3077 8.50004H8.11537C8.32819 8.50004 8.50639 8.57184 8.64997 8.71544C8.79356 8.85902 8.86535 9.03722 8.86535 9.25004C8.86535 9.46286 8.79356 9.64106 8.64997 9.78464C8.50639 9.92822 8.32819 10 8.11537 10H6.3077C6.23077 10 6.16024 10.0321 6.09612 10.0962C6.03202 10.1603 5.99997 10.2308 5.99997 10.3077V20.6923C5.99997 20.7692 6.03202 20.8397 6.09612 20.9039C6.16024 20.968 6.23077 21 6.3077 21H17.6922C17.7692 21 17.8397 20.968 17.9038 20.9039C17.9679 20.8397 18 20.7692 18 20.6923V10.3077C18 10.2308 17.9679 10.1603 17.9038 10.0962C17.8397 10.0321 17.7692 10 17.6922 10H15.8846C15.6718 10 15.4936 9.92822 15.35 9.78464C15.2064 9.64106 15.1346 9.46286 15.1346 9.25004C15.1346 9.03722 15.2064 8.85902 15.35 8.71544C15.4936 8.57184 15.6718 8.50004 15.8846 8.50004H17.6922C18.1974 8.50004 18.625 8.67504 18.975 9.02504C19.325 9.37504 19.5 9.80261 19.5 10.3077V20.6923C19.5 21.1974 19.325 21.625 18.975 21.975C18.625 22.325 18.1974 22.5 17.6922 22.5L6.3077 22.5ZM11.25 4.71926L9.92687 6.04236C9.77817 6.19108 9.60414 6.26448 9.40477 6.26256C9.20542 6.26063 9.02819 6.18211 8.87308 6.02699C8.72819 5.87186 8.65319 5.69621 8.64808 5.50006C8.64294 5.30393 8.71794 5.1283 8.87308 4.97316L11.3673 2.47894C11.5481 2.29815 11.759 2.20776 12 2.20776C12.241 2.20776 12.4519 2.29815 12.6327 2.47891L15.1269 4.97314C15.2653 5.11161 15.3362 5.28307 15.3394 5.48754C15.3426 5.69202 15.2718 5.87183 15.1269 6.02696C14.9718 6.18208 14.7936 6.25964 14.5923 6.25964C14.391 6.25964 14.2128 6.18208 14.0577 6.02696L12.7499 4.71924V15C12.7499 15.2128 12.6782 15.391 12.5346 15.5346C12.391 15.6782 12.2128 15.75 12 15.75C11.7872 15.75 11.609 15.6782 11.4654 15.5346C11.3218 15.391 11.25 15.2128 11.25 15V4.71926Z\" fill=\"currentColor\"/>"
});
export default Icon;